import classNames from 'classnames';
import type { MouseEventHandler } from 'react';

import { Loading } from '@revelio/core';

import { useSafeChart } from './ChartProvider';
import styles from './chart-loader.module.css';

export const ChartLoader = ({
  onClick,
}: {
  onClick?: MouseEventHandler<HTMLDivElement>;
}) => {
  const { variant, onEditClick } = useSafeChart();
  const handleClick = onClick ?? onEditClick;
  const capLoaderToViewport = variant === 'report';

  return (
    <div
      className={classNames(
        styles.chartLoader,
        capLoaderToViewport && styles.cappedToViewport
      )}
      onClick={handleClick}
    >
      <Loading size="sm" />
    </div>
  );
};
